<template>
    <form ref="form-detalhe-atualizacao" v-on:submit.prevent="executeCreate(model)" novalidate>
        <div class="row">
            <div class="col-sm-12 ajustaLista" v-html="textoAtualizacao">
            </div>
        </div>

        <!--<button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>-->
        <!--<label class="custom-control custom-checkbox">
            <input type="checkbox" id="confirmaLeitura" name="confirmaLeitura" class="custom-control-input" @click="onAtivaClose()">
            <span class="custom-control-indicator"></span>
            <span class="custom-control-description">Confirmar leitura.</span>
        </label>-->
        <!--<button type="button" class="btn btn-default float-right" @click="onBack()" v-bind:disabled="ativaClose">
            <span>Fechar</span>
        </button>-->

        <button type="button" class="btn btn-success float-right" @click="onBack()">
            <span>CONFIRMAR LEITURA</span>
        </button>
    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'
    import auth from '@/common/auth'

    export default {
        name: "form-detalhe-atualizacao",
        mixins: [base],
        props: { textoAtualizacao: String, id: Number },
        data: () => ({

            cpfCarregado: false,
            ativaClose: true,
            escolaLogadaId: 0,
            usuarioLogado: 0,

            model: {
                ChangeLogId: 0,
                ColaboradorId: 0,
                EscolaId:0
            },

            form: "form-detalhe-atualizacao",

            resources: {
                create: 'ChangeLogConfirmacaoLeitura',
            },

        }),

        methods: {

            executeCreate: function (model) {
                //@TASK_14818
                model.ChangeLogId = this.id;
                model.ColaboradorId = this.usuarioLogado;
                model.EscolaId = this.escolaLogadaId;
                model.attributeBehavior = "SalvarConfirmacaoLeitura";

                new Api(this.resources.create + "/SalvarConfirmacaoLeitura").post(model).then(data => {                    
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            onAtivaClose: function () {
                if (document.getElementById("confirmaLeitura").checked)
                    this.ativaClose = false;
                else
                    this.ativaClose = true;
            },

            onBack: function () {
                this.executeCreate({ChangeLogId:this.id, ColaboradorId:this.usuarioLogado, EscolaId:this.escolaLogadaId});

                this.$emit('on-back')
            }
        },

        mounted() {
            this.escolaLogadaId = +auth.currentUser().tenant;

            this.usuarioLogado = auth.currentUser().sub;
        }
    };
</script>
<style>
    .ajustaLista ul,
    .ajustaLista ol {
        padding-left: 40px;
    }

    .ajustaLista li {
        list-style-type: inherit;
    }

    .ObrLeitura .modal-header {
        text-align: center !important;
        display: block !important;
        font-weight:bold;
    }
</style>

